import ListStore from '@/store/core/ListStore';
import { action, computed } from 'mobx';
import services from '@/api/services';
import { Taxpayer } from '@/store/types';
import { taxpayerTypes } from '@/store/mapping';
import { dateFormat, numGroup } from '@/utils/filters';

export default class TaxpayerStore extends ListStore<Taxpayer> {
  @computed get processedData() {
    if (!this.data) return;
    return {
      ...this.data,
      type: taxpayerTypes[this.data.type]?.label || '-',
      createDate: dateFormat(this.data.createDate, {
        format: 'DD.MM.YYYY',
        addHours: 0,
      }),
      sumIncome: numGroup(this.data.sumIncome),
      sumTax: numGroup(this.data.sumTax),
      sumPayTax: numGroup(this.data.sumPayTax),
      sumDebt: numGroup(this.data.sumDebt),
    };
  }

  @action.bound async fetch(id: string | number) {
    this.isFetching = true;
    try {
      const { data } = await services.selfEmployee.getTaxpayerProfile(id);
      this.data = data;
    } catch (e) {
      console.error(e);
    } finally {
      this.isFetching = false;
    }
  }
}
